import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '../../store'

import type { ConfigState } from './Config.slice'

export const selectConfig = (state: RootState) => state.config

export const selectInMaintenance = createSelector(
  selectConfig,
  (config: ConfigState) => config.inMaintenance,
)

export const selectForceReloadVersion = createSelector(
  selectConfig,
  (config: ConfigState) => config.softUpdate,
)

export const allowedCompanyId = createSelector(
  selectConfig,
  (config: ConfigState) => config.allowedCompanyId,
)
